import type { Check } from './types'

import {
  baseAssistantOverviewUrl,
  CheckStatus,
  checkStatus,
} from '@app/application/sf-assistant-checks/constants'

function getSfAssistantElement(): HTMLElement | null {
  return document.getElementById('sfAssistantChecksHelper')
}

export function showSfAssistantChecks(): boolean {
  return !!getSfAssistantElement()
}

interface sfAssistantChecksData {
  showElement: boolean
  parsedAccountId?: number | undefined
  parsedReconciliationId?: number | undefined
  lastMessagebusId?: number | undefined
  channel?: string
  preemptive?: boolean
}

export function getSfAssistantChecksData(): sfAssistantChecksData {
  const sfAssistantElement = getSfAssistantElement()
  const showElement = !!sfAssistantElement
  let sfAssistantChecksData: sfAssistantChecksData = { showElement }

  if (showElement) {
    const data = sfAssistantElement.dataset

    const parsedAccountId = data.accountId
      ? parseInt(data.accountId)
      : undefined
    const parsedReconciliationId = data.reconciliationId
      ? parseInt(data.reconciliationId)
      : undefined
    const lastMessagebusId = data.lastMessagebusId
      ? parseInt(data.lastMessagebusId)
      : undefined
    const channel = data.messageBusChannel
    const preemptive = !!data.preemptive

    sfAssistantChecksData = {
      showElement,
      parsedAccountId,
      parsedReconciliationId,
      lastMessagebusId,
      channel,
      preemptive,
    }
  }

  return sfAssistantChecksData
}

export function checkIsDismissedOrCompleted(check: Check): boolean {
  return [
    checkStatus.DISMISSED as CheckStatus,
    checkStatus.COMPLETED as CheckStatus,
  ].includes(check.status)
}

export function checkIsCompleted(check: Check): boolean {
  return check.status === checkStatus.COMPLETED
}

export function doneChecks(
  checks: Check[],
  remarks: Record<string, Record<string, unknown>>
): Check[] {
  if (!checks) {
    return []
  }

  return checks.filter((check) => remarks?.[check.id]?.done === true)
}

export function pendingChecks(
  checks: Check[],
  remarks: Record<string, Record<string, unknown>>
): Check[] {
  if (!checks) {
    return []
  }

  return checks.filter((check) => remarks?.[check.id]?.done === false)
}

export function sfAssistantOverviewUrl(
  objectType: string,
  objectId: number | undefined
): string {
  const params = new URLSearchParams()
  params.append('locale', window.I18n.locale)
  params.append('country', window.Silverfin.currentFirmCountry)
  params.append('firm_id', window.Silverfin.currentFirmId)
  params.append('company_id', window.Silverfin.currentCompanyId)
  params.append('period_id', window.Silverfin.currentLedgerId().toString())
  params.append('object_type', objectType)
  params.append('object_id', (objectId || '').toString())

  return `${baseAssistantOverviewUrl}${params.toString()}`
}
